import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import LevelsGrid from './SetStaffPermissionsPageContentItems/LevelsGrid';


const SetStaffPermissionsPageContent = () => {
    return (
        <LevelsGrid />
    );
};

export default SetStaffPermissionsPageContent;
